























































































import Vue from "vue";
// import { resturant } from "@/mocks/client";
import AddItemToBasket from "@/views/client/AddItemToBasket.vue";
import MenuCategoriesNavigator from "@/views/client/MenuCategoriesNavigator.vue";
import {
  GET_CLIENT_MENU,
  GET_CLIENT_MENU_TYPE,
  GET_ORDER_DISH,
  GET_ORDER_STATUS,
} from "@/queries/customer/query.graphql";
import { bus } from "@/utils/event-emitter";
import store from "@/store";
import { apolloClient } from "@/apollo";
import DeleteMenuItemConfirmation from "@/views/dashboard/deleteMenuItemConfirmation.vue";
import { DELETE_ORDER_DISH } from "@/queries/customer/mutation.graphql";
import { load } from "@/services/stripe/stripe";
import environment from "@/enviroment";
import { isTimeInRange } from "@/utils/date";

export default Vue.extend({
  beforeRouteEnter(to, from, next) {
    apolloClient
      .query({
        query: GET_CLIENT_MENU_TYPE,
      })
      .then(({ data: { Menu } }) => {
        if (Menu[0]) {
          if (Menu[0].menuType === "ONLINE") {
            apolloClient
              .query({
                query: GET_ORDER_STATUS,
                variables: {
                  id: store.getters["authModule/orderId"],
                },
              })
              .then(({ data: { Order } }) => {
                store.commit("loadersModule/toggleGlobalLoader", false);
                if (Order[0].status === "ORDERING") {
                  next();
                } else {
                  next({ name: "order-complete", params: { ...to.params } });
                }
              });
          } else {
            if (Menu[0].pdfUrl.length) {
              location.replace(Menu[0].pdfUrl);
            } else {
              next({ name: "error" });
            }
          }
        }
      });
  },
  methods: {
    inRange(from, to) {
      if (from && to) {
        return isTimeInRange(from, to);
      } else return true;
    },
    selectItem(item): void {
      this.selectedItem = item;
      this.show = true;
      this.selectionMode = null;
    },
    deleteOrderDishWithModifiers() {
      this.$apollo
        .mutate({
          mutation: DELETE_ORDER_DISH,
          variables: {
            orderModifierItemId: [],
            orderDishId: this.selectedForDelete.id,
          },
          update: (cache, { data: { b } }) => {
            if (b.affected_rows) {
              const data: any = cache.readQuery({
                query: GET_ORDER_DISH,
              });
              data.OrderDish = data.OrderDish.filter(
                (el) => el.id !== this.selectedForDelete.id
              );
              cache.writeQuery({
                query: GET_ORDER_DISH,
                data,
              });
            }
          },
        })
        .then((data) => (this.openDeleteConfirmation = false));
    },
  },
  data() {
    return {
      resturant: null,
      selectedItem: {},
      show: false,
      selectionMode: null,
      openDeleteConfirmation: false,
      selectedForDelete: null,
    };
  },
  apollo: {
    resturant: {
      query: GET_CLIENT_MENU,
      variables(): any {
        return {
          id: this.$route.params.menuId,
        };
      },
      update(data: any) {
        if (data.Menu[0].User && data.Menu[0].User.stripeAccountId) {
          load(environment.stripeKey, {
            stripeAccount: data.Menu[0].User.stripeAccountId,
          });
        }
        data.Menu[0].Categories = data.Menu[0].Categories.filter(
          (category: any) => {
            if (!category.Dishes.length) {
              return false;
            } else {
              let length = 0;
              category.Dishes.forEach((dish: any) => {
                if (
                  this.inRange(dish.availableFrom, dish.availableTo) &&
                  dish.inStock
                ) {
                  length++;
                  return;
                }
              });
              console.log(length);

              return length !== 0;
            }
          }
        );
        return data.Menu[0];
      },
    },
  },
  components: {
    AddItemToBasket,
    MenuCategoriesNavigator,
    DeleteMenuItemConfirmation,
  },
  mounted() {
    bus.$on("selectedOrderDishForDelete", (selected: any) => {
      this.selectedForDelete = selected;
      this.openDeleteConfirmation = true;
    });
    bus.$on("edit-order-dish", (data) => {
      this.show = true;
      this.selectionMode = "edit";
      // this.selectedItem
      const category = this.resturant.Categories.find(
        (el: any) => el.id === data.Dish.categoryId
      );
      this.selectedItem = category.Dishes.find(
        (el: any) => el.id === data.Dish.id
      );
    });
  },
});
